import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { TABLELIST_SELECTOR } from "../../../crossconcern/utilities/properties/selector.property";
import { TableInfo } from "../../../crossconcern/models/tablelist/tableinfo.model";

@Component({
    selector: TABLELIST_SELECTOR,
    templateUrl: "./tablelist.component.html"
})
export class TableListComponent implements OnChanges {

    @Input() public tableInfo: TableInfo;
    @Output() public onHeaderClicked: EventEmitter<[string, boolean]> = new EventEmitter();

    public onButtonOverEven = false;
    public onButtonOverOdd = false;
    public onButtonOverIndex: number;
    public tableEmptyInfo: TableInfo;

    private currentSortKey: string;

    constructor() {
        this.tableEmptyInfo = null;
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty("tableInfo") && typeof changes.tableInfo.currentValue !== "undefined") {
            this.fillTableEmptyRows();
        }
    }

    public onButtonOver(index: number) {
        if (index % 2 === 0) {
            this.onButtonOverEven = true;
        } else {
            this.onButtonOverOdd = true;
        }
        this.onButtonOverIndex = index;
    }

    public onButtonLoseFocus() {
        this.onButtonOverEven = false;
        this.onButtonOverOdd = false;
        this.onButtonOverIndex = null;
    }

    public onHeaderClick(key: string) {
        if (this.tableInfo.headers[key].sortEnabled) {
            if (this.tableInfo.headers[key].selected) {
                this.tableInfo.headers[key].sortAsc = this.tableInfo.headers[key].sortAsc === false;
            } else {
                for (const tableHeaderKey of this.objectKeys(this.tableInfo.headers)) {
                    if (this.tableInfo.headers[tableHeaderKey].selected) {
                        this.tableInfo.headers[tableHeaderKey].selected = false;
                    }
                }
                this.tableInfo.headers[key].selected = true;
            }
            this.currentSortKey = key;
            this.onHeaderClicked.emit([
                key, this.tableInfo.headers[key].sortAsc
            ]);
        }
    }

    // Fill table with empty rows when table info has less elements than itemsPerPage
    public fillTableEmptyRows() {
        let rowsToFill = 0;
        if (this.tableInfo.items == null) {
            rowsToFill = this.tableInfo.itemsPerPage;
        } else if (this.tableInfo.items.length < this.tableInfo.itemsPerPage) {
            rowsToFill = this.tableInfo.itemsPerPage - this.tableInfo.items.length;
        }
        const items: unknown[] = [];
        const columnLength = this.objectKeys(this.tableInfo.headers).length - 1;
        let column = [];
        for (let i = 0; i < rowsToFill; i++) {
            column = [];
            for (let j = 0; j < columnLength; j++) {
                column.push(null);
            }
            items.push(column);
        }
        this.tableEmptyInfo = new TableInfo(null, items);

    }

    public objectKeys(obj) {
        return Object.keys(obj);
    }

    public isSortAscEnabled(key: string) {
        return this.tableInfo.headers[key].sortEnabled &&
            this.currentSortKey === key &&
            this.tableInfo.headers[key].sortAsc;
    }

    public isSortDescEnabled(key: string) {
        return this.tableInfo.headers[key].sortEnabled &&
            this.currentSortKey === key &&
            !this.tableInfo.headers[key].sortAsc;

    }
}
